import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import LoaderGlobal from "../molecules/LoaderGlobal";

type Props = {
  children?: React.ReactNode;
  stylingType?: "events_styling" | "booking_proposal_styling";
};

const PageTemplate = ({ children, stylingType = "events_styling" }: Props) => {
  const { generalSettings, loading } = useSelector(
    (state: RootState) => state.generalSettings,
  );

  if (loading || Object.keys(generalSettings).length === 0) {
    return <LoaderGlobal />;
  }

  const styling = generalSettings[stylingType];

  return (
    <div
      style={{
        minHeight: "100vh",
        color: styling.textColor,
        fontFamily: '"' + styling.font_family + '"',
      }}
      className="w-full min-h-full flex gap-[10px] flex-col"
    >
      <Box
        sx={(theme) => {
          if (!styling.backgroundImageUrl) {
            return {
              minHeight: "100vh",
              backgroundColor: styling.backgroundColor,
              color: styling.textColor,
              button: {
                // Add button-specific styles here if needed
                color: `${styling.buttonTextColor}`,
                backgroundColor: styling.buttonBackgroundColor,
                "&:hover": {
                  backgroundColor: styling.buttonHoverBackgroundColor,
                  color: styling.buttonHoverTextColor,
                },
              },
              [theme.breakpoints.down("md")]: !styling.backgroundMobileImageUrl
                ? {
                    backgroundColor: styling.backgroundColor,
                    color: styling.textColor,
                    backgroundImage: "none",
                  }
                : {
                    minHeight: "100vh",
                    width: "100%",
                    backgroundImage: `url(${styling.backgroundMobileImageUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundColor: `${styling.backgroundImageOverlay}`,
                    backgroundBlendMode: "overlay",
                    mixBlendMode: "overlay",
                  },
            };
          } else {
            return {
              minHeight: "100vh",
              width: "100%",
              backgroundImage: `url(${styling.backgroundImageUrl})`,
              backgroundColor: `${styling.backgroundImageOverlay}`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundBlendMode: "overlay",
              mixBlendMode: "overlay",
              button: {
                // Add button-specific styles here if needed
                color: `${styling.buttonTextColor}`,
                backgroundColor: styling.buttonBackgroundColor,
                "&:hover": {
                  backgroundColor: styling.buttonHoverBackgroundColor,
                  color: styling.buttonHoverTextColor,
                },
              },
              [theme.breakpoints.down("md")]: !styling.backgroundMobileImageUrl
                ? {
                    backgroundColor: styling.backgroundColor,
                    color: styling.textColor,
                    backgroundImage: "none",
                  }
                : {
                    minHeight: "100vh",
                    width: "100%",
                    backgroundImage: `url(${styling.backgroundMobileImageUrl})`,
                    backgroundColor: `${styling.backgroundImageOverlay}`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundBlendMode: "overlay",
                    mixBlendMode: "overlay",
                  },
            };
          }
        }}
        className={`flex items-center flex-col py-8 px-4 text-[${styling.textColor}]`}
      >
        {children}
      </Box>
    </div>
  );
};

export default PageTemplate;
